module.exports = "<p class=\"control-label\">{{t('actionHostname.hostname')|e}}</p>\n<p>{{hostname|e}}</p>\n";
